import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (param) => async (dispatch) => {
    let formdata = new FormData();
    
    param.map((k,v) => {
        formdata.append(v,k);    
    });
    
    const url = ApiUrl2+'helpdesk-sendmedia';
    const argument = {
        method: 'POST',
        headers : {
            'Authorization': 'Bearer ' + UserToken,
        },
        body: formdata
    };
    const response = await doFetch(url,argument);
    
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    return response;
};